<template>
	<BaseLayout :footer-full="true">
		<div class="container">
			<div class="col-8-md col-offset-2-md">
				<h1 class="heading-1 text-align-center mb-100 mb-200-md">{{ pageTitle }}</h1>
				<section class="grid-md">
					<article class="position-relative">
						<div class="module">
							<div class="module-header">
								<h2 class="heading-5">Terms and Conditions</h2>
							</div>
							<div class="module-section">
								<p>
									You must agree to the following terms and conditions in order to receive an advisory
									fee waiver when opening a “Qualifying New Account” (as defined below). For each
									Qualifying New Account, Fundrise Advisors LLC will waive its fees applicable to your
									Fundrise account for a certain period of time, as determined by Fundrise Advisors
									LLC.
								</p>

								<p>
									The advisory fee waiver offer is only valid for selected individuals who are not
									currently invested in Fundrise, open a Qualifying New Account, and fulfill the
									conditions of the reward program. Individuals must be targeted with the offer in
									order to be eligible. The advisory fee waiver will be applied to the Qualifying New
									Account shortly after the initial investment settles.
								</p>

								<p>
									A Qualifying New Account is (i) a new individual Fundrise account opened by you
									through the reward program page (or advertisement), and (ii) through which an
									initial investment meeting the minimum amount indicated in the reward program (if
									required) and within the timeframe mentioned in the reward program and such
									transaction has settled. Please note, (i) the advisory fee waiver is not available
									to individuals who invest through an IRA, and (ii) by signing up as an investor on
									the Fundrise platform, individuals become a client of Fundrise Advisors LLC.
									Fundrise is not responsible for incorrect entry or other failure on the part of the
									investor to meet the standards of a Qualifying New Account.
								</p>

								<p>
									Advisory fee waivers only apply to management fees charged by Fundrise Advisors LLC
									for investment advisory services and does not include any fees and expenses charged
									by Fundrise Advisors LLC or its affiliates to the individual funds available on the
									Fundrise Platform and held in your Fundrise Account.
								</p>

								<p>
									The advisory fee waiver offer is not valid with any other offers and is
									non-transferrable. The offer is available to U.S. residents only. Fundrise Advisors
									LLC reserves the right to change the offer terms or terminate this offer at any time
									without notice for any reason, to limit the amount of advisory fee waivers you are
									eligible to receive, and to refuse or recover any advisory fee waiver if Fundrise
									Advisors LLC determines that it was obtained under wrongful or fraudulent
									circumstances, that inaccurate or incomplete information was provided in opening the
									Qualifying New Account or connecting the bank account, that any rules or regulations
									would be violated, or that any terms of the Fundrise Client Agreement have been
									violated. Other restrictions may apply.
								</p>
							</div>
						</div>
					</article>
				</section>
			</div>
		</div>
	</BaseLayout>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';

const pageTitle = 'Advisory Fee Waiver Reward Program Terms and Conditions';

useHead({
	title: pageTitle,
	meta: [
		{ property: 'og:title', content: pageTitle },
		{ name: 'description', content: pageTitle },
		{ property: 'og:description', content: pageTitle }
	]
});
</script>
